export default __webpack_public_path__ + "static/media/uiuxDesign.6f974261.png";